import { ORDER_DELIVERY_METHODS_INFORMATION } from '@app/components/pages/account/order-status/order-pickup-and-delivery/constants';
import {
  DELIVERY,
  PICKUP,
  PICKUP_AND_DELIVERY,
  SHOP_ONLINE,
  DROPBOX
} from '@app/components/pages/checkout/PickUpAndDelivery/constants';
import { generateTaxAndFrightPayloadInSummaryPage } from '@app/components/pages/summary-and-payment/utils';
import {
  PICK_UP_TYPE,
  USER_TYPE_GUEST,
  DELIVERY_TYPE
} from '@app/constants/commonConstants';
import { getTaxAndFreight } from '@app/store/checkout/actions';
import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';

const useCalculateFreightWrapper = (
  fullfillmentType,
  isGuestEnhancedEnabled,
  pageType
) => {
  const { values } = useFormikContext() || {};
  const dispatch = useDispatch();
  const orderId = useSelector(s => s?.orders?.current);
  const userType = useSelector(s => s?.common?.userType);
  const isGuest = userType === USER_TYPE_GUEST;
  const physicalStoreId = useSelector(
    s => s?.checkout?.pickUp?.physicalStoreId
  );
  const allShippingMethods = useSelector(s =>
    isGuest && isGuestEnhancedEnabled
      ? s?.checkout?.shopOnline?.guestShippingMethods
      : s?.checkout?.shopOnline?.methods
  );
  let orderShippingCode = '';
  let orderShippingMethod = '';
  if (fullfillmentType === DELIVERY_TYPE) {
    // setting shipviacode for delivery
    orderShippingMethod =
      useSelector(
        s => s?.orders?.byId?.[orderId]?.fullfillment?.shopOnline?.method
      ) || '';
    orderShippingCode = allShippingMethods?.find(
      code => code?.displayName === orderShippingMethod
    )?.code;
  } else if (fullfillmentType === PICK_UP_TYPE || fullfillmentType === PICKUP) {
    // setting shipviacode for pickup
    const allPickupMethods = useSelector(s => s?.checkout?.pickUp?.methods);
    orderShippingMethod =
      useSelector(
        s => s?.orders?.byId?.[orderId]?.fullfillment?.pickup?.method
      ) || '';
    orderShippingCode = allPickupMethods?.find(
      code => code?.displayName === orderShippingMethod
    )?.code;
  } else if (fullfillmentType === DROPBOX) {
    // setting shipviacode for dropBox
    const allDropBoxMethods = useSelector(s => s?.checkout?.dropBox?.methods);
    orderShippingMethod =
      useSelector(
        s => s?.orders?.byId?.[orderId]?.fullfillment?.dropBox?.method
      ) || '';
    orderShippingCode = allDropBoxMethods?.find(
      code => code?.displayName === orderShippingMethod
    )?.code;
  }
  const shipModeId = useSelector(
    s =>
      s?.checkout?.[
        fullfillmentType === PICK_UP_TYPE ? PICKUP : fullfillmentType
      ]?.shipModeId
  );
  const deliveryShipModeId = useSelector(
    s => s?.checkout?.shopOnline?.shipModeId
  );
  const promoCodeApplied = useSelector(
    state => state?.checkout?.orderHeaderInformation?.appliedPromotionCode
  );
  const intialAddress = {
    firstName: '',
    lastName: '',
    nickName: '',
    email: '',
    phone: '',
    address1: '',
    address2: '',
    address3: '',
    country: '',
    city: '',
    state: '',
    zipcode: ''
  };
  const address = {
    ...intialAddress,
    ...useSelector(
      s =>
        s?.orders?.byId[orderId]?.fullfillment?.[
          fullfillmentType === DELIVERY ? SHOP_ONLINE : fullfillmentType
        ]?.[ORDER_DELIVERY_METHODS_INFORMATION[fullfillmentType]?.address]
    )
  };
  const countryInfo = useSelector(s => s?.dealer?.countryInfo);
  const countryCode = countryInfo?.find(
    country => country?.displayName === address?.country
  );
  const country = countryCode?.code || address?.country;
  const orderShippinginstruction = useSelector(
    s =>
      s?.orders?.byId?.[orderId]?.fullfillment?.pickup?.instructions ||
      s?.orders?.byId?.[orderId]?.fullfillment?.dropBox?.dropBoxInstructions ||
      s?.orders?.byId?.[orderId]?.fullfillment?.shopOnline?.shippingInstructions
  );
  const allDeliveryInstructions = useSelector(
    s =>
      s?.checkout?.dropBox?.instructions ||
      s?.checkout?.pickUp?.instructions ||
      s?.checkout?.shopOnline?.instructions
  );
  const deliveryInstructionCode = allDeliveryInstructions?.find(
    code => code?.displayName === orderShippinginstruction
  )?.code;
  const taxAndFreight = useSelector(s => s?.checkout?.taxAndFreight);
  const guestShipping = useSelector(
    s => s?.checkout?.[SHOP_ONLINE]?.guestShippingMethods
  );
  let method = [
    {
      shipViaCode: orderShippingCode || '',
      shipInstCode: deliveryInstructionCode || '',
      shipLabel: orderShippingMethod || ''
    }
  ];
  if (
    isGuest &&
    pageType === PICKUP_AND_DELIVERY &&
    fullfillmentType === DELIVERY
  ) {
    method = taxAndFreight?.map(itm => ({
      shipViaCode: itm.shipViaCode,
      shipInstCode: values?.shopOnline?.instructions?.code || '',
      shipLabel:
        guestShipping.find(fnd => fnd?.code === itm?.shipViaCode)
          ?.displayName || ''
    }));
  }
  const taxAndFreightTrigger = (
    requestByDate,
    showToasterFulFillment,
    fieldValueObj,
    availabilityMessage,
    isCallingFromCounter = false
  ) =>
    dispatch(
      getTaxAndFreight({
        ...generateTaxAndFrightPayloadInSummaryPage({
          orderId,
          fullfillmentType,
          requestByDate,
          physicalStoreId,
          shipModeId,
          deliveryShipModeId,
          address,
          country,
          isGuestEnhancedEnabled,
          method,
          values,
          promoCodeApplied
        }),
        showToasterFulFillment,
        fieldValueObj,
        availabilityMessage,
        pageType,
        isCallingFromCounter
      })
    );

  return { taxAndFreightTrigger };
};

export default useCalculateFreightWrapper;
